export default {
    //查询全部工作类型
    jobType: "/settings/type/job",
    //  settings -type  查询工作类型
    getjobTypeshow: "/settings/jobType/show",
    //   setting-jobtype 修改工作类型
    getjobtypeupdate: "/settings/jobType/update",
    // setting-jobtype 新增工作类型
    getjobtypeadd: "/settings/jobType/add",
    // setting -jobtype 删除工作类型
    getjobtypedelete: "/settings/jobType/delete",
    // 获取当前系统设置
    getSystemSettings:"/settings/systemSettings/show",
    getSystemSettingsAccountOptions:"/settings/systemSettings/accountOptions",
    // 修改系统配置
    getSettingsupdate:"/settings/systemSettings/update",
    // 定时任务列表数据
    getCronJobShow:"/settings/cronJob/show",
    // 获取taskeylist
    getTaskKeyList:"/settings/cronJob/getTaskKeyList",
    // 获取人员邮箱列表
    getAccountEmailList:"/settings/cronJob/getAccountEmailList",
    // 新增定时任务
    getCronJobAdd:"/settings/cronJob/add",
    // 修改定时任务
    getCronJobUpdate:"/settings/cronJob/update",
    // 删除定时任务
    getCronJobDelete:"/settings/cronJob/delete",
    // 获取cron说明
    getCronRemark:"/settings/cronJob/getCronRemark",
    // 开启/关闭定时任务
    getEnable:"/settings/cronJob/enable",
    // 执行一次定时任务
    getCronRunNow:"/settings/cronJob/run",
    // 视频上传
    getAppAdUpload:"/settings/AppAdvertising/upload",
    // 广告新增
    getAppAdvertistAdd:"/settings/AppAdvertising/add",
    // Type-Ap License 查询展示列表
    getApLicenseTypeShow:"/settings/apLicenseType/show",
    // 获取运营执照类型
    getShowVo:"/settings/apLicenseType/showVo",
    // 新增执照类型
    getAddVo:"/settings/apLicenseType/add",
    // 删除营业执照
    getApLicenseTypeDelete:"/settings/apLicenseType/delete",
    // 修改营业执照
    getApLicenseTypeUpdate:"/settings/apLicenseType/update",
    // 修改营业执照启用/禁用状态
    getApLicenseTypeUpdateStatus:"/settings/apLicenseType/updateStatus",
    // 展示规则列表
    getGlTransRulesList:"/settings/glTransRules/show",
    // 删除规则
    getGlTransRulesDelete:"/settings/glTransRules/delete",
    // 新增规则
    getGlTransRulesAdd:"/settings/glTransRules/add",
    // 修改规则
    getGlTransRulesUpload:"/settings/glTransRules/update",
    // GL-Module
    getGLByModuleList:"/settings/glTransRules/moduleList",
    // 请求工作补贴下拉框数据
    getDropdownDict:"/settings/employeesTimeAllowance/dropdown",
    // 请求工作补贴表格数据
    getEmployeesTableList:"/settings/employeesTimeAllowance/list",
    // 新增雇员补贴时长数据
    getEmployeesTimeAdd:"/settings/employeesTimeAllowance/add",
    // 修改雇员补贴时长数据
    getEmployeesTimeUpdate:"/settings/employeesTimeAllowance/update",
    // 雇员补贴时长 根据ID 删除
    getEmployeesTimeDelete:"/settings/employeesTimeAllowance/delete",
    //  signature 列表
    getSignaTureList:"/settings/Signature/show",
    // signature 上传文件
    getSignaTureUpload:"/settings/Signature/uploadSignature",
       // signature 新增
    getSignaTureAdd:"/settings/Signature/add",
    // singnatrue  删除
    getSignaTureDele:"/settings/Signature/delete",
     // singnatrue  修改
    getSignaTureUpdate:"/settings/Signature/update",
    // insuranceType 列表数据
    getInsuranceTypeShow:"settings/insuranceType/showInsuranceType",
   // insuranceType 列表新增
   getInsuranceTypeAdd:"settings/insuranceType/addInsuranceType",
     // insuranceTypeUpdate 列表修改
   getInsuranceTypeUpdate:"settings/insuranceType/updateInsuranceType",
      // insuranceTypeUpdate 列表删除
   getInsuranceTypeDel:"settings/insuranceType/delete",
        // insuranceType 列表修改状态
   getInsuranceTypeStatus:"settings/insuranceType/updateStatus",
   // GlAcctAssociation -- 列表数据
    getGlAcctAssociationShow:"/settings/GlAcctAssociation/show",
   //  GlAcctAssociation -- 下拉框
   getGlAcctTypeOption:"/settings/GlAcctAssociation/glAcctTypeOption",

 //  GlAcctAssociation -service code- 下拉框
   getServiceCodeDict:"/settings/GlAcctAssociation/serviceCodeOption",
   //  GlAcctAssociation -- 新增
   getGlAcctAdd:"/settings/GlAcctAssociation/add",
   //  GlAcctAssociation -- 修改
    getGlAcctUpdate:"/settings/GlAcctAssociation/update",
    //  GlAcctAssociation -- 删除
     getGlAcctDel:"/settings/GlAcctAssociation/del", 
    //  年假 --获取列表数据
    getRuleList:"/settings/annual/rule/getRuleList",
    // 年假 --新增
    getRuleAdd:"/settings/annual/rule/saveRule",
    // 年假 --修改
    getRuleUpdate:"/settings/annual/rule/updateRule",
    // 年假--删除
    getRuleDel:"/settings/annual/rule/delRule",
    // bank by group列表数据
    getBankByGroupShow:"/settings/bankGroup/show",
    // bank 新增
     getBankByGroupAdd:"/settings/bankGroup/add",
    //  根据ID 查询详情
    getBankByGroupById:"/settings/bankGroup/byId",
    // 修改数据
     getBankByGroupUpdate:"/settings/bankGroup/update",
    //  删除
     getBankByGroupDelete:"/settings/bankGroup/delete",
    //  GL Chart 获取列表数据
    getGLChartShow:"settings/glChart/show",
    // GL Chart 新增
    getGLChartAdd:"/settings/glChart/add",
    //  GL Chart修改
    getGLChartUpdate:"/settings/glChart/update",
    //  GL Chart删除
    getGLChartDelete:"/settings/glChart/delete",
    //  GLChartSubType列表展示
     getGlAcctSubTypeShow:"/settings/glAcctSubType/show",
        // GLChartSubType新增
    getGlAcctSubTypeAdd:"/settings/glAcctSubType/add",
    // 修改GLChartSubType
    getGlAcctSubTypeUpdate:"/settings/glAcctSubType/update",
      // GLChartSubType删除
    getGlAcctSubTypeDelete:"/settings/glAcctSubType/delete",
      //  ApModuleGlAcct列表展示
     getApModuleGlAcctShow:"/settings/apModuleGlAcctRange/show",
        // ApModuleGlAcct新增
    getApModuleGlAcctAdd:"/settings/apModuleGlAcctRange/add",
    // 修改ApModuleGlAcct
    getApModuleGlAcctUpdate:"/settings/apModuleGlAcctRange/update",
      //ApModuleGlAcct删除
    getApModuleGlAcctDelete:"/settings/apModuleGlAcctRange/delete",
}
